export enum MatchesSortBy {
  RELATIONSHIP = 'RELATIONSHIP',
  DATE = 'DATE',
}
